/** Base API alineada con `environment.path` de la app Angular (`…/api/`). */
export function getApiBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_API_BASE_URL as string | undefined;
  const base = (fromEnv?.trim() || 'https://servave-backend.com/api/').replace(/\/?$/, '/');
  return base;
}

export function apiUrl(...segments: string[]): string {
  const base = getApiBaseUrl();
  const path = segments
    .map((s) => s.replace(/^\/+|\/+$/g, ''))
    .filter(Boolean)
    .join('/');
  return `${base}${path}`;
}
